<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { initTheme } from '@/utils/theme'

export default {
  name: 'App',
  created() {
    initTheme(this.$store)
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
